import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./userSlice";
import subuserReducer from "./subuserSlice";

// Combine multiple reducers into a single rootReducer
const rootReducer = combineReducers({
  user: userReducer,
  subuser: subuserReducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
// import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import userReducer from "./userSlice";
// import subuserReducer from "./subuserSlice";

// // Combine multiple reducers into a single rootReducer
// const rootReducer = combineReducers({
//   user: userReducer,
//   subuser: subuserReducer,
// });

// // Create the Redux store with combined reducers
// export const store = configureStore({
//   reducer: rootReducer,
// });
